import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.25 17.25C13.25 17.9404 12.6904 18.5 12 18.5C11.3096 18.5 10.75 17.9404 10.75 17.25C10.75 16.5596 11.3096 16 12 16C12.6904 16 13.25 16.5596 13.25 17.25ZM12 5.625C9.8599 5.625 8.125 7.3599 8.125 9.5V10C8.125 10.4832 8.51675 10.875 9 10.875C9.48325 10.875 9.875 10.4832 9.875 10V9.5C9.875 8.3264 10.8264 7.375 12 7.375H12.8C13.8079 7.375 14.625 8.19208 14.625 9.2C14.625 10.2079 13.8079 11.025 12.8 11.025H12C11.5168 11.025 11.125 11.4168 11.125 11.9V14C11.125 14.4832 11.5168 14.875 12 14.875C12.4832 14.875 12.875 14.4832 12.875 14V12.7742C14.8148 12.7343 16.375 11.1494 16.375 9.2C16.375 7.22558 14.7744 5.625 12.8 5.625H12Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
